export default function BackgroundIllustration() {
  return (
    <svg
      width="456"
      height="188"
      viewBox="0 0 456 188"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Background Illustration</title>
      <rect
        x="373.083"
        y="101"
        width="142.917"
        height="142.917"
        rx="71.4583"
        fill="white"
        fillOpacity="0.02"
      />
      <circle
        cx="444.542"
        cy="172.458"
        r="53.2523"
        fill="white"
        fillOpacity="0.02"
      />
      <ellipse
        cx="444.542"
        cy="172.458"
        rx="26.8537"
        ry="26.8537"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M444.488 171.073L450.252 172.63C450.705 172.752 450.819 173.334 450.461 173.621L450.461 173.622L437.357 184.089C436.876 184.475 436.182 183.916 436.52 183.341L441.15 174.826L435.378 173.279C434.94 173.162 434.779 172.574 435.2 172.26L448.273 161.818C448.755 161.432 449.448 161.991 449.11 162.566L444.488 171.073Z"
        fill="black"
      />
      <g opacity="0.26">
        <circle
          cx="2.49197"
          cy="2.49197"
          r="2.49197"
          transform="matrix(0.236507 -0.97163 -0.97163 -0.236507 107.827 16.9023)"
          fill="white"
          fillOpacity="0.5"
        />
        <circle
          cx="2.13597"
          cy="2.13597"
          r="2.13597"
          transform="matrix(0.236507 -0.97163 -0.97163 -0.236507 297.586 57.6479)"
          fill="white"
          fillOpacity="0.8"
        />
        <circle
          cx="1.42398"
          cy="1.42398"
          r="1.42398"
          transform="matrix(0.236507 -0.97163 -0.97163 -0.236507 294.286 17.7729)"
          fill="white"
          fillOpacity="0.8"
        />
        <circle
          cx="1.42398"
          cy="1.42398"
          r="1.42398"
          transform="matrix(0.236507 -0.97163 -0.97163 -0.236507 162.858 152.836)"
          fill="white"
          fillOpacity="0.8"
        />
        <circle
          cx="2.13597"
          cy="2.13597"
          r="2.13597"
          transform="matrix(0.236507 -0.97163 -0.97163 -0.236507 404.515 44.7139)"
          fill="white"
          fillOpacity="0.8"
        />
        <circle
          cx="2.49197"
          cy="2.49197"
          r="2.49197"
          transform="matrix(0.236507 -0.97163 -0.97163 -0.236507 73.1522 144.141)"
          fill="white"
          fillOpacity="0.5"
        />
      </g>
      <path
        d="M341.672 245.898C368.891 322.168 452.91 361.89 529.336 334.616C605.763 307.342 645.652 223.402 618.433 147.131C591.215 70.8608 507.196 31.1393 430.769 58.4131C354.343 85.6869 314.454 169.627 341.672 245.898Z"
        stroke="#FBFBFB"
        strokeOpacity="0.04"
        strokeWidth="0.849311"
      />
      <path
        d="M260.922 261.857C296.854 362.546 407.772 414.984 508.665 378.978C609.559 342.973 662.218 232.16 626.286 131.472C590.354 30.7834 479.436 -21.6545 378.542 14.3507C277.649 50.356 224.99 161.169 260.922 261.857Z"
        stroke="#FBFBFB"
        strokeOpacity="0.04"
        strokeWidth="0.849311"
      />
      <path
        d="M187.213 285.128C233.357 414.432 375.797 481.773 505.364 435.535C634.93 389.297 702.556 246.992 656.412 117.688C610.268 -11.6159 467.827 -78.9562 338.261 -32.7185C208.694 13.5192 141.069 155.825 187.213 285.128Z"
        stroke="#FBFBFB"
        strokeOpacity="0.04"
        strokeWidth="0.849311"
      />
      <path
        d="M103.752 310.458C160.208 468.657 334.479 551.046 492.999 494.475C651.52 437.905 734.257 263.799 677.801 105.6C621.346 -52.5986 447.075 -134.987 288.554 -78.4169C130.034 -21.8466 47.2965 152.259 103.752 310.458Z"
        stroke="#FBFBFB"
        strokeOpacity="0.04"
        strokeWidth="1.0391"
      />
    </svg>
  );
}
